import { IApiService } from 'web_core_library';
import { TRAINING_ID } from '../base/constants';
import { ICycleStatus, ICycleStatusApiResponse, ITrainingStatisticsApiResponse } from './types';

export function createCycleService() {
  let ApiService: IApiService;

  // this call returns training statistic including the amount of finished cycles = last cycle id
  const getUserStatistic = () => {
    const filter = `trainingId/${TRAINING_ID}`;
    return ApiService.action<ITrainingStatisticsApiResponse>('training_statistics', {
      method: 'get',
      urlParams: {
        userId: ApiService.getUserId(),
        filter,
      },
    });
  };

  // this call allow to fetch given session of given cycle to see if session is completed and which workouts are finished
  const getCycleSession = (cycleId: number, sessionId: number) => {
    const filter = `trainingId/${TRAINING_ID}/cycleId/${cycleId}/sessionId/${sessionId}`;
    return ApiService.action<ICycleStatusApiResponse>('training_cycles', {
      method: 'get',
      urlParams: {
        userId: ApiService.getUserId(),
        filter,
      },
    });
  };

  // this call allow to fetch the full cycle
  const getCycle = (cycleId: number) => {
    const filter = `trainingId/${TRAINING_ID}/cycleId/${cycleId}`;
    return ApiService.action<ICycleStatusApiResponse>('training_cycles', {
      method: 'get',
      urlParams: {
        userId: ApiService.getUserId(),
        filter,
      },
    });
  };

  // this call creates a new cycle (must consist of one initial assessment session)
  const createCycle = (cycle: ICycleStatus) => {
    return ApiService.action('training_cycles', {
      method: 'post',
      urlParams: {
        userId: ApiService.getUserId(),
      },
      data: {
        trainingcycles: [cycle],
      },
    });
  };

  // this call updates information about current/given cycle
  const updateCycles = (cycles: ICycleStatus[]) => {
    return ApiService.action('training_cycles', {
      method: 'patch',
      urlParams: {
        userId: ApiService.getUserId(),
      },
      data: {
        trainingcycles: cycles,
      },
    });
  };

  const service = {
    init: (ApiServiceInstance: IApiService) => {
      ApiService = ApiServiceInstance;
    },
    getUserStatistic,
    getCycleSession,
    getCycle,
    createCycle,
    updateCycles,
  };
  return service;
}

const CycleService = createCycleService();
export default CycleService;
